import HeaderTabs from "../interface/HeaderTabs";
import { NoSignal } from "../Interface";
import UserInfo from "../login/UserInfo";
import Pressable from "../other/Pressable";
import RolePermissionsEditor from './RolePermissionsEditor';
import { can } from '../../utils/permissions';

function RolsApp(props) {
    const { socket, userInfo } = props;

    if (!can(userInfo, 'MANAGE_ROLE_PERMISSIONS')) {
        return (
            <>
                <NoSignal socket={socket} />
                <div style={{ padding: 20 }}>
                    <UserInfo {...props} socket={socket} />
                    <HeaderTabs {...props} />
                    
                    <div style={{ 
                        textAlign: 'center', 
                        marginTop: 100,
                        padding: 40,
                        backgroundColor: '#f8f9fa',
                        borderRadius: 12,
                        maxWidth: 600,
                        margin: '100px auto'
                    }}>
                        <h2 style={{ color: '#dc3545' }}>⛔ Accés denegat</h2>
                        <p style={{ color: '#666', fontSize: 16, marginBottom: 30 }}>
                            No tens permisos per gestionar els rols de la colla.
                        </p>
                        <Pressable 
                            style={{ 
                                backgroundColor: '#007bff',
                                color: 'white',
                                padding: '12px 24px',
                                borderRadius: 8,
                                textDecoration: 'none',
                                display: 'inline-block'
                            }} 
                            href='/'
                        >
                            Tornar a l'inici
                        </Pressable>
                    </div>
                </div>
            </>
        );
    }

    return (
        <>
            <NoSignal socket={socket} />
            
            <div style={{ minHeight: '100vh', backgroundColor: '#fafafa' }}>
                <div style={{ padding: 20 }}>
                    <UserInfo {...props} socket={socket} />
                    <HeaderTabs {...props} />
                    
                    <Pressable 
                        style={{ backgroundColor: '#eee' }} 
                        className="boto-back" 
                        href='/gestio'
                    >
                        ← Tornar a gestió
                    </Pressable>
                </div>
                
                <RolePermissionsEditor userInfo={userInfo} />
            </div>
        </>
    );
}

export default RolsApp; 